(function () {
  var PREORDER_TEXT = /pre\s*-?\s*order/i;
  var BACKORDER_CARD_TEXT = /pre\s*-?\s*order|back\s*-?\s*order|^\s*og\s+sassy\s*$/i;
  var ADD_BUTTON_SELECTOR = '.product-card-wrapper .quick-add__submit, .card-wrapper .quick-add__submit';

  function replaceTextNode(node, replacement) {
    if (!node) return false;

    if (node.nodeType === Node.TEXT_NODE) {
      if (PREORDER_TEXT.test(node.textContent)) {
        node.textContent = node.textContent.replace(PREORDER_TEXT, replacement);
        return true;
      }
      return false;
    }

    var changed = false;
    node.childNodes.forEach(function (child) {
      changed = replaceTextNode(child, replacement) || changed;
    });
    return changed;
  }

  function setButtonText(button, text) {
    button.classList.add('quick-add__submit--preorder');
    button.setAttribute('data-preorder-card-button', 'true');

    var label = button.querySelector('.main-atc__label__text');
    if (label) {
      label.textContent = text;
      return;
    }

    var changed = false;
    button.childNodes.forEach(function (child) {
      if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
        child.textContent = ' ' + text + ' ';
        changed = true;
      }
    });

    if (!changed) button.insertAdjacentText('afterbegin', text + ' ');
  }

  function isBackorderCard(button) {
    var card = button.closest('.product-card-wrapper, .card-wrapper');
    if (!card) return false;

    var title = card.querySelector('.card__heading, h3, [id^="title-"]');
    return !!title && BACKORDER_CARD_TEXT.test(title.textContent || '');
  }

  function isUnavailable(button) {
    return button.disabled || button.getAttribute('aria-disabled') === 'true';
  }

  function fixButton(button) {
    if (!button) return;
    if (button.closest('[data-preorder-product="true"]')) return;
    if (isBackorderCard(button)) {
      if (!isUnavailable(button) && !PREORDER_TEXT.test(button.textContent || '')) setButtonText(button, 'Pre-order');
      return;
    }
    if (isUnavailable(button) || !PREORDER_TEXT.test(button.textContent || '')) return;

    var label = button.querySelector('.main-atc__label__text');
    if (label) {
      label.textContent = 'Add to cart';
      return;
    }

    replaceTextNode(button, 'Add to cart');
  }

  function fixPreorderLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(ADD_BUTTON_SELECTOR)) fixButton(scope);
    scope.querySelectorAll(ADD_BUTTON_SELECTOR).forEach(fixButton);
  }

  function startGuard() {
    fixPreorderLabels(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          var parent = mutation.target.parentElement;
          if (parent) fixPreorderLabels(parent.closest('.product-card-wrapper, .card-wrapper') || parent);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches && node.matches(ADD_BUTTON_SELECTOR)) fixButton(node);
          fixPreorderLabels(node);
        });

        if (mutation.target && mutation.target.nodeType === Node.ELEMENT_NODE) {
          fixPreorderLabels(mutation.target.closest('.product-card-wrapper, .card-wrapper') || mutation.target);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGuard);
  } else {
    startGuard();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixPreorderLabels(event.target);
  });
})();
